



































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/agiles/common';
import * as Components from '@/agiles/components';

@Component
export default class PersonalEditor extends Vue {
  public item: Common.User = null;

  public apiBtnDisabled: boolean = true;
  public created() {
    //ユーザーをロードする
    this.$api.formatter.ensureListLoaded('user','notificationCode').then(()=>{
      this.$api.execute(new Common.UserLoadQuery()).then(res => (this.item = res));
    });    
  }

  public onEdit() {
    this.apiBtnDisabled = false;
  }

  public async onExec(item: any) {
    return this.$api.update(item).then(obj => {
      (this.$refs.editor as Components.Editor).setState(Common.editorStates.Read);
      this.reload();
      this.$api.license.countOnlyOwned = obj.countOnlyOwned;
    });
  }

  public reload() {
    //ユーザーをロードする
    this.$api.execute(new Common.UserLoadQuery()).then(res => (this.item = res));
    this.apiBtnDisabled = true;
  }

  public onIssueApiKey() {
    //ランダムな文字列を発行する
    this.item.apiKey = this.getUUID();
    (this.$refs.editor as Vue).$forceUpdate();
  }

  private getUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx'.replace(/[xy]/g, function(c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }
}
